document.addEventListener('DOMContentLoaded', () => {
    const productForm = document.querySelector('form[action*="/cart/add"]');
    
    if (productForm) {
        productForm.addEventListener('submit', function(e) {
            e.preventDefault();
            
            const formData = new FormData(this);
            
            fetch('/cart/add.js', {
                method: 'POST',
                body: formData
            })
            .then(response => response.json())
            .then(data => {
                // Trigger cart drawer update
                document.dispatchEvent(new CustomEvent('cart:updated'));
                
                // Open cart drawer
                if (window.cartDrawer) {
                    window.cartDrawer.open();
                }
            })
            .catch(error => {
                console.error('Error adding to cart:', error);
            });
        });
    }
});